type ElectronTheiaWindow = Window & {
    electronTheiaCore?: unknown;
    electronTheiaFilesystem?: unknown;
};

export const isElectronTheia = (): boolean => {
    if (typeof window === 'undefined') return false;

    const currentWindow: ElectronTheiaWindow = window as ElectronTheiaWindow;
    return Boolean(
        currentWindow.electronTheiaCore ||
        currentWindow.electronTheiaFilesystem ||
        navigator.userAgent.toLowerCase().includes('electron')
    );
};

export const isBrowserOnlyTheia = (): boolean => !isElectronTheia();
